import mediator from 'modules/mediator';
import { subsequentlyAddToBasket } from 'modules/addAndRemoveFromBasket';
import track from 'modules/tracking/dataLayer';
import { AddMultipleToBasket } from 'autogen/swagger/all';
import ResizeObserver from 'resize-observer-polyfill';

function addToBasket() {
    const productsToAdd = document.getElementById('js-questionnaireRecommendationAddToBasketProducts').innerHTML;
    const bundleRelation = document.querySelector('.js-questionnaireRecommendation').dataset.responseId;
    const bundleType = 'Questionnaire';
    const productIds = JSON.parse(productsToAdd);

    const params = {
        productIds,
        bundleRelation,
        bundleType,
        listName: bundleType
    };

    AddMultipleToBasket(params).then((response) => {
        mediator.publish('updateQuantities', 'basket');
        mediator.publish('updateMiniBasketView');
        subsequentlyAddToBasket(productIds);
        track(response.dataLayerDto);
    });
}

function descriptionResizeObserverCallback(entries) {
    entries.forEach((entry) => {
        const { target } = entry;
        const { clientHeight, scrollHeight } = target;
        const parent = target.parentNode;
        const readMoreButton = parent.querySelector('.js-questionnaireRecommendationDescriptionReadMore');

        if (scrollHeight > clientHeight) {
            readMoreButton.style.display = 'block';
        } else {
            readMoreButton.style.display = 'none';
        }
    });
}

function focusProduct(event) {
    const { currentTarget } = event;
    const { checked } = currentTarget;
    const questionnaireRecommendationProductItem = currentTarget.closest('.js-questionnaireRecommendationProductItem');
    const productItem = questionnaireRecommendationProductItem.querySelector('.js-productItem');

    if (checked) {
        productItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
        questionnaireRecommendationProductItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
}

export default () => {
    document.querySelectorAll('.js-questionnaireRecommendationAddToBasket').forEach((node) => {
        node.addEventListener('click', addToBasket);
    });

    const descriptionResizeObserver = new ResizeObserver(descriptionResizeObserverCallback);
    document.querySelectorAll('.js-questionnaireRecommendationDescriptionOverflow').forEach((node) => {
        descriptionResizeObserver.observe(node);
    });

    document.querySelectorAll('.js-questionnaireRecommendationProductCheckbox').forEach((checkbox) => {
        checkbox.addEventListener('change', focusProduct);
    });

    const infoBoxTop = document.querySelector('.js-questionnaireRecommendationInfoBoxIntersectTop');
    const infoBoxBottom = document.querySelector('.js-questionnaireRecommendationInfoBoxIntersectBottom');
    const infoBoxSticky = document.querySelector('.js-questionnaireRecommendationInfoBoxSticky');
    const infoBoxIntersection = {
        top: false,
        bottom: false
    };
    const headerHeight = 115;

    // const sd = scrollDirection({
    //     up: () => {
    //         console.log('going up', infoBoxIntersection);
    //     },
    //     down: () => {
    //         console.log('going down', infoBoxIntersection);
    //     }
    // });

    function adjustToStickyHeader(sticky) {
        if (sticky) {
            infoBoxSticky.style.top = `${25 + headerHeight}px`;
        } else {
            infoBoxSticky.style.top = '25px';
        }
    }

    function infoBoxStickyIntersectionObserverCallback(entries) {
        const [entry] = entries;
        const { boundingClientRect, rootBounds } = entry;

        if (boundingClientRect.height < rootBounds.height - headerHeight) {
            infoBoxSticky.style.position = 'sticky';
            infoBoxSticky.style.overflow = 'hidden';
            adjustToStickyHeader(true); // This is now set to an arbitrary value because redux was removed, and we didn't want to remove this file and its dependencies yet.
            // sd.unsubscribe();
        } else {
            infoBoxSticky.style.position = 'static';
            // sd.subscribe();
        }
    }

    function infoBoxEdgesIntersectionObserverCallback(entries) {
        entries.forEach((entry) => {
            if (entry.target === infoBoxTop) {
                infoBoxIntersection.top = entry.isIntersecting;
            }

            if (entry.target === infoBoxBottom) {
                infoBoxIntersection.bottom = entry.isIntersecting;
            }
        });
    }

    const infoBoxEdgesIntersectionObserver = new IntersectionObserver(infoBoxEdgesIntersectionObserverCallback);
    infoBoxEdgesIntersectionObserver.observe(infoBoxTop);
    infoBoxEdgesIntersectionObserver.observe(infoBoxBottom);

    const infoBoxStickyIntersectionObserver = new IntersectionObserver(infoBoxStickyIntersectionObserverCallback, {
        threshold: 1
    });
    infoBoxStickyIntersectionObserver.observe(infoBoxSticky);
};
